// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__hRh4N","disabled":"Select_disabled__4GyIl","label":"Select_label__dwCt3","select":"Select_select__OlUEn"};